import type { Props } from "../../core/types/tsx/components/order-detail/GuaranteeCard.types";

export function GuaranteeCard({ guarantee }: Props) {
	return (
		<section className='rounded-2xl bg-secondary p-6 border border-secondary'>
			<div className='flex items-center gap-2 text-sm font-semibold text-gray-800 mb-3'>
				<svg
					xmlns='http://www.w3.org/2000/svg'
					className='h-5 w-5 text-blue-500'
					viewBox='0 0 20 20'
					fill='currentColor'
				>
					<path
						fillRule='evenodd'
						d='M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z'
						clipRule='evenodd'
					/>
				</svg>
				100% Satisfacción Garantizada
			</div>
			<ul className='grid gap-2 sm:grid-cols-2 text-sm text-gray-700'>
				{guarantee.points.map((point) => (
					<li key={point.text} className='flex items-start gap-2'>
						<span
							className='mt-1 h-2 w-2 rounded-full bg-blue-400'
							aria-hidden
						/>
						<span>{point.text}</span>
					</li>
				))}
			</ul>
			{guarantee.actionLabel && (
				<button
					type='button'
					onClick={guarantee.onAction}
					disabled={guarantee.actionDisabled || guarantee.actionLoading}
					className='mt-4 inline-flex cursor-pointer items-center gap-2 rounded-full border border-primary/20 bg-white px-4 py-2.5 text-sm font-semibold text-primary hover:bg-blue-50 disabled:cursor-not-allowed'
				>
					{guarantee.actionLoading ? "Procesando..." : guarantee.actionLabel}
				</button>
			)}
		</section>
	);
}

export default GuaranteeCard;
